import { fillAdminCourseDetails } from "../../Pages/AdminCourseManagement/Fills";
import { ajaxRequest } from "../Ajax/ajax";
import { successToast } from "../utils";

// removes if there is no email given to frontend
export function removeExistingTutorInvitation(userId, courseId, btn=false){

    const url = '/course/' + courseId.toString() + '/tutor/' + userId.toString() + '/uninvite'

    const data = {}

    const success = function(data){
        successToast('Das Angebot an den/die Tutor/-in wurde erfolgreich zurückgezogen', 'Erfolg', 12500, true);
        fillAdminCourseDetails(courseId);
    }

    return ajaxRequest(url, success, data, btn)

  }